module.exports = __webpack_public_path__ + "img/brief-bg.82ee2c62.png";